import React, { Fragment } from "react";
import useForm from "react-hook-form";
import { connect } from "react-redux";
import store from "store";
import ImageUpload from "./imageUpload";

const ProductForm = (props) => {
  const { register, handleSubmit, errors } = useForm(); // initialise the hook
  var {
    info,
    onChangeUrl,
    searchProductUrl,
    searchUrlStatus,
    isEdit,
    imageUrl,
    onChangeImage,
    removeImage,
  } = props;

  const onSubmit = (data) => {
    if (data !== "") {
      // onSubmitForm()/
      props.onClickConfirm(data);
    } else {
      errors.showMessages();
    }
  };

  return (
    <Fragment>
      <div className="container-fluid">
        <div className="card-body">
          <form
            id="product-form"
            className="needs-validation"
            noValidate=""
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="row">
              {/****** All Fields *****/}
              <div className="col-12 col-md-6 mb-2">

                {/**** Brand name *****/}
                <div className="col-12">
                  <label className="mb-2">
                    Brand Name
                    <span>*</span>
                  </label>
                  <input
                    className="form-control mb-2"
                    name="name"
                    type="text"
                    defaultValue={info?.name}
                    placeholder="Brand Name"
                    onChange={(e) => onChangeUrl(e.target.value)}
                    ref={register({ required: true })}
                  />
                   <span style={{ color: "#ff5370" }}>{errors.name && "Brand name is required"}</span>
                </div>

                {/**** Page title *****/}
                <div className="col-12">
                  <label className="mb-2">
                    Page Title
                    <span>*</span>
                  </label>
                  <input
                    className="form-control mb-2"
                    name="sTitle"
                    type="text"
                    defaultValue={info?.sTitle}
                    placeholder="Page Title"
                    ref={register({ required: true })}
                  />
                   <span style={{ color: "#ff5370" }}>{errors.sTitle && "Page title is required"}</span>
                </div>

                {/**** Page url *****/}
                <div className="col-12">
                  <label className="mb-2">
                    Page Url
                    <span>*</span>
                  </label>
                  <input
                    className="form-control"
                    name="sUrl"
                    type="text"
                    defaultValue={info?.sUrl}
                    placeholder="Page Url"
                    onChange={(e) => onChangeUrl(null, e.target.value)}
                    ref={register({ required: true })}
                  />
                   <span style={{ color: "#ff5370" }}>{errors.sUrl && "Page url is required"}</span>
                </div>

                {/**** Page keyword *****/}
                <div className="col-12">
                  <label className="mb-2">
                    Page Keyword
                    <span>*</span>
                  </label>
                  <input
                    className="form-control mb-2"
                    name="sKeyword"
                    type="text"
                    defaultValue={info?.sKeyword}
                    placeholder="Page Keyword"
                    ref={register({ required: true })}
                  />
                   <span style={{ color: "#ff5370" }}>{errors.sKeyword && "Page keyword is required"}</span>
                </div>
              </div>

              {/***** Image upload *****/}
              <div className="col-12 col-md-6 mb-2">
                <label className="mb-2">
                  Cover Image
                  <span>*</span>
                </label>
                <div className="row">
                  <div className="col-md-2"></div>
                  <div className="col-md-8">
                    <ImageUpload
                      imageUrl={imageUrl}
                      onChangeImage={onChangeImage}
                      removeImage={removeImage}
                    />
                  </div>
                </div>
              </div>

              {/**** Page description *****/}
              <div className="col-12">
                <label className="mb-2">
                  Page Description
                  <span>*</span>
                </label>
                <input
                  className="form-control mb-3"
                  name="shortDescription"
                  type="text"
                  defaultValue={info?.shortDescription}
                  placeholder="Page Description"
                  ref={register({ required: true })}
                />
                  <span style={{ color: "#ff5370" }}>
                    {errors.shortDescription && "Page description is required"}
                  </span>
              </div>
            </div>
            <div className="p-15 float-end">
              <button className="btn btn-primary " type="submit" style={{ padding: "6px 28px", fontSize: "14px" }}>
                {isEdit ? "Update" : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};
export default connect()(ProductForm);
